<template>
  <div>
    <b-row style="margin-right:0px !important">
        <b-col cols="3" md="3" xl="3">
            <b-form-group>
                <b-form-input type="text" v-model="filter" :placeholder="$t('Type to Search')" style="margin-bottom:1rem;padding:5px"></b-form-input>
            </b-form-group>
        </b-col>
        <b-col cols="6" md="5" xl="6" >
        </b-col>
        <b-col cols="3" md="4" xl="3" v-if="curItem" >
            <b-button variant="success" @click="save">{{ $t('Save') }}</b-button>
            <b-button @click="load">{{ $t('Cancel') }}</b-button>
        </b-col>
    </b-row>
    <b-row style="margin-right:0px !important">
      <b-col cols="3" md="3" xl="3">
        <b-list-group>
          <b-list-group-item id="button-list-group-item" :variant="getVariant(item)" v-for="item in registrySettingGroups" :key="item.group_id" @click="selectSettingsGroups(item)">{{ $t(item.description) }}</b-list-group-item>
        </b-list-group>
      </b-col>
      <b-col cols="9" md="9" xl="9">
        <b-form-group label-align="right" v-if="curItem" v-for="itemData in registrySettingsEdit" :key="itemData.setting_id" :label="$t(itemData.description)" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <div v-if="itemData.raw_values.length">
            <b-input-group>
              <b-form-input v-if="isInput(itemData)" :type="getInputType(itemData)" v-model="itemData.raw_values[0].value"/>
              <b-input-group-append>
                <span :id="itemData.name" v-if="isTooltip(itemData)">
                  <b-img :src="questionImage"/>
                </span>
                <b-tooltip :target="itemData.name" triggers="hover">
                  {{ itemData.tooltip }}
                </b-tooltip>
              </b-input-group-append>
            </b-input-group>
            <b-form-checkbox class="mt-2" v-if="isCheckBox(itemData)" v-model="itemData.raw_values[0].value" unchecked-value="0" value="1"/>
            <b-form-textarea id="bordered-textarea" v-if="isTextArea(itemData)" rows="3" v-model="itemData.raw_values[0].value"/>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isNotTooltip: [
        'null_prepaid_traffic_if_tarif_change',
        'notification_message_from',
        'notification_message_subject',
        'payment_notification_subject',
        'invoice_subject',
        'smtp_relay',
        'smtp_port',
        'add_tel_num_to_invoice',
        'hide_password_in_service_link',
        'tc_get_stat_interval',
        'ext_payment_inet_on',
        'lite_search_cnt',
        'radius_realm',
        'radius_max_session_age',
        'radius_do_accounting',
        'radius_do_interim_accounting',
        'megogo_partner_id',
        'megogo_user_prefix',
        'megogo_salt',
        'megogo_period_type',
        'lifestream_address',
        'Lifestream_user_prefix',
        'iptvportal_address',
        'iptvportal_username',
        'iptvportal_password',
        'address',
        'username',
        'password',
        'operator_tag',
        'Nationality',
        'region_tag',
        'location_tag',
        'tc_get_data_interval',
        'save_balance',
        'save_zero_sum_invoices'
      ],
      tooltip: [
        {name: 'system_currency', tooltip: this.$i18n.t('tooltip_system_currency')},
        {name: 'bytes_in_kbyte', tooltip: this.$i18n.t('tooltip_bytes_in_kbyte')},
        {name: 'discount_barrier', tooltip: this.$i18n.t('tooltip_discount_barrier')},
        {name: 'flow_discounts_per_period', tooltip: this.$i18n.t('tooltip_flow_discounts_per_period')},
        {name: 'traffic_agregation_interval', tooltip: this.$i18n.t('tooltip_traffic_agregation_interval')},
        {name: 'aggregation_todisc_barrier', tooltip: this.$i18n.t('tooltip_aggregation_todisc_barrier')},
        {name: 'force_prepaid_change', tooltip: this.$i18n.t('tooltip_force_prepaid_change')},
        {name: 'card_user_prefix', tooltip: this.$i18n.t('tooltip_card_user_prefix')},
        {name: 'card_callback_enable', tooltip: this.$i18n.t('tooltip_card_callback_enable')},
        {name: 'default_dialup_cid', tooltip: this.$i18n.t('tooltip_default_dialup_cid')},
        {name: 'default_dialup_csid', tooltip: this.$i18n.t('tooltip_default_dialup_csid')},
        {name: 'card_tel_uid_len', tooltip: this.$i18n.t('tooltip_card_tel_uid_len')},
        {name: 'balance_notification_email', tooltip: this.$i18n.t('tooltip_balance_notification_email')},
        {name: 'notification_message_by_wintray', tooltip: this.$i18n.t('tooltip_notification_message_by_wintray')},
        {name: 'notification_borders', tooltip: this.$i18n.t('tooltip_notification_borders')},
        {name: 'notification_message', tooltip: this.$i18n.t('tooltip_notification_message')},
        {name: 'payment_notification_message', tooltip: this.$i18n.t('tooltip_payment_notification_message')},
        {name: 'invoice_text', tooltip: this.$i18n.t('tooltip_invoice_text')},
        {name: 'smtp_fqdn', tooltip: this.$i18n.t('tooltip_smtp_fqdn')},
        {name: 'enchanced_telephony_invoice_algorithm', tooltip: this.$i18n.t('tooltip_enchanced_telephony_invoice_algorithm')},
        {name: 'legacy_invoices', tooltip: this.$i18n.t('tooltip_legacy_invoices')},
        {name: 'invoice_rules', tooltip: this.$i18n.t('tooltip_invoice_rules')},
        {name: 'invoice_advanced_rules', tooltip: this.$i18n.t('tooltip_invoice_advanced_rules')},
        {name: 'document_dir', tooltip: this.$i18n.t('tooltip_document_dir')},
        {name: 'create_document', tooltip: this.$i18n.t('tooltip_create_document')},
        {name: 'create_document_bill', tooltip: this.$i18n.t('tooltip_create_document_bill')},
        {name: 'create_document_invoice', tooltip: this.$i18n.t('tooltip_create_document_invoice')},
        {name: 'create_document_certificate', tooltip: this.$i18n.t('tooltip_create_document_certificate')},
        {name: 'create_document_detail', tooltip: this.$i18n.t('tooltip_create_document_detail')},
        {name: 'create_document_keep_time', tooltip: this.$i18n.t('tooltip_create_document_keep_time')},
        {name: 'fw_rule_offset', tooltip: this.$i18n.t('tooltip_fw_rule_offset')},
        {name: 'login_prefix_separator', tooltip: this.$i18n.t('tooltip_login_prefix_separator')},
        {name: 'dynamic_ip_unlink_timeout', tooltip: this.$i18n.t('tooltip_dynamic_ip_unlink_timeout')},
        {name: 'encrypt_passwords', tooltip: this.$i18n.t('tooltip_encrypt_passwords')},
        {name: 'web_message_group', tooltip: this.$i18n.t('tooltip_web_message_group')},
        {name: 'tel_report_dont_show_id', tooltip: this.$i18n.t('tooltip_tel_report_dont_show_id')},
        {name: 'hotspot_refresh_timeout', tooltip: this.$i18n.t('tooltip_hotspot_refresh_timeout')},
        {name: 'ext_payment_notify', tooltip: this.$i18n.t('tooltip_ext_payment_notify')},
        {name: 'archive_db_name', tooltip: this.$i18n.t('tooltip_archive_db_name')},
        {name: 'default_vat_rate', tooltip: this.$i18n.t('tooltip_default_vat_rate')},
        {name: 'megogo_duration', tooltip: this.$i18n.t('tooltip_megogo_duration')}
      ],
      questionImage: require('@/assets/img/question.png'),
      curItem: null,
      filter: ''
    }
  },
  methods: {
    save () {
      for (let elEdit of this.registrySettingsEdit) {
        for (let el of this.registrySettings) {
          if (el.setting_id === elEdit.setting_id) {
            if (el.raw_values[0].value !== elEdit.raw_values[0].value) {
              elEdit.object_id = 0
              this.$store.dispatch('Settings/UPDATE_REGISTRY_SETTING', elEdit).then(response => {
                if (response.data.error) {
                  this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
                } else {
                  this.$root.$emit('makeToasts')
                }
              })
            }
            break
          }
        }
      }
      setTimeout(this.$store.dispatch, 500, 'Settings/GET_REGISTRY_SETTING_GROUPS', 1)
    },
    getVariant (item) {
      if (this.curItem) {
        if (item.group_id === this.curItem.group_id) {
          return 'info'
        }
      }
      return 'default'
    },
    selectSettingsGroups (item) {
      if (item === this.curItem) {
        this.curItem = null
      } else {
        this.curItem = item
        this.$store.dispatch('Settings/GET_REGISTRY_SETTINGS', {group_id: this.curItem.group_id, object_id: 0})
      }
    },
    isTooltip (itemData) {
      let isTooltip = true
      for (let el of this.isNotTooltip) {
        if (itemData.name === el) {
          isTooltip = false
        }
      }
      return isTooltip
    },
    isInput (itemData) {
      return [1, 2, 3, 4, 5].includes(itemData.value_type) && ![8, 16].includes(itemData.validation_flags)
    },
    isCheckBox (itemData) {
      return itemData.validation_flags === 8
    },
    isTextArea (itemData) {
      return itemData.validation_flags === 16
    },
    getInputType (itemData) {
      switch (itemData.value_type) {
        case 1:
          return 'number'
        case 2:
          return 'number'
        case 3:
          return 'number'
        case 4:
          return 'text'
        case 5:
          return 'text'
        default:
          return 'text'
      }
    },
    load () {
      this.curItem = null
    }
  },
  computed: {
    registrySettingGroups () {
      return this.$store.getters['Settings/REGISTRY_SETTING_GROUPS'].filter((val) => {
        return this.$t(val.description).toUpperCase().includes(this.filter.toUpperCase())
      })
    },
    registrySettings () {
      return this.$store.getters['Settings/REGISTRY_SETTINGS']
    },
    registrySettingsEdit () {
      let registrySettingsEdit = JSON.parse(JSON.stringify(this.registrySettings))
      for (let el of registrySettingsEdit) {
        for (let elTooltip of this.tooltip) {
          if (el.name === elTooltip.name) {
            el.tooltip = elTooltip.tooltip
          }
        }
      }
      return registrySettingsEdit
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_REGISTRY_SETTING_GROUPS', 1)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/system/settingsSystem/main.vue